import React from "react";
import {BaseComponent} from "@renta-apps/athenaeum-react-common";
import { Button, ButtonContainer, ButtonType, Checkbox, Form, OneColumn, Panel} from "@renta-apps/athenaeum-react-components";
import ConstructionSite from "../../../models/server/ConstructionSite";
import Localizer from "../../../localization/Localizer";
import OrganizationContractSettings from "@/models/server/OrganizationContractSettings";
import SaveOrganizationContractSettingsRequest from "@/models/server/requests/SaveOrganizationContractSettingsRequest";

interface IOrganizationContractSettingsProps {
    constructionSite: ConstructionSite;
    readonly?: boolean;
}

interface IOrganizationContractSettingsState {
    settings: OrganizationContractSettings | null;
}

export default class OrganizationContractSettingsPanel extends BaseComponent<IOrganizationContractSettingsProps, IOrganizationContractSettingsState> {

    public state: IOrganizationContractSettingsState = {
        settings: null,
    };

    private get constructionSite(): ConstructionSite {
        return this.props.constructionSite;
    }

    private get readonly(): boolean {
        return !!this.props.readonly;
    }

    private async onCheckboxSettingsChange(value: boolean, key: keyof OrganizationContractSettings): Promise<void> {
        let settings = this.state.settings;
        if (!settings) {
            settings = new OrganizationContractSettings();
        }
        (settings[key] as boolean) = value;
        await this.setState({settings});
    }

    private async flyoutSuccessAsync(message: string): Promise<void> {
        await this.getPage().alertMessageAsync(message, true, true);
    }

    private async settingsSubmitAsync(): Promise<void> {
        const request: SaveOrganizationContractSettingsRequest = {
            organizationContractId: this.props.constructionSite.organizationContractId,
            settings: this.state.settings
        };
        await this.postAsync("api/constructionSiteManagement/saveOrganizationContractSettings", request);
        await this.flyoutSuccessAsync(Localizer.organizationContractSettingsPanelSuccessMessage);
    }
    
    public async initializeAsync(): Promise<void> {
        await super.initializeAsync();
        const settings: OrganizationContractSettings = this.constructionSite.organizationContract?.organizationContractSettings ?? new OrganizationContractSettings();
        await this.setState({settings})
    }

    public render(): React.ReactNode {
        return (
            <Panel className="flex-2" title={Localizer.organizationContractSettingsPanelTitle}>
                <div className="col-12">
                    {
                        (this.constructionSite) &&
                        (
                            <Form onSubmit={async () => await this.settingsSubmitAsync()}>
                                
                                <OneColumn>
                                    
                                    <Checkbox label={Localizer.organizationContractSettingsPanelSendAnInvitation}
                                              value={this.state.settings?.inviteContactPerson}
                                              readonly={this.readonly}
                                              onChange={async (_, value) => await this.onCheckboxSettingsChange(value, "inviteContactPerson")}
                                    />
                                    
                                    <Checkbox label={Localizer.organizationContractSettingsPanelSendAnInvitationOnWOAcceptanceRequest}
                                              value={this.state.settings?.sendInvitationOnAcceptanceRequired}
                                              readonly={this.readonly}
                                              onChange={async (_, value) => await this.onCheckboxSettingsChange(value, "sendInvitationOnAcceptanceRequired")}
                                    />
                                    
                                    <Checkbox label={Localizer.organizationContractSettingsPanelSendWOAcceptanceRequest}
                                              value={this.state.settings?.sendAcceptanceEmail}
                                              readonly={this.readonly}
                                              onChange={async (_, value) => await this.onCheckboxSettingsChange(value, "sendAcceptanceEmail")}
                                    />
                                    
                                </OneColumn>
                                
                                <ButtonContainer>
                                    
                                    <Button type={ButtonType.Orange}
                                            label={Localizer.formSave}
                                            icon={{name: "far save"}}
                                            disabled={this.readonly}
                                            submit
                                    />

                                </ButtonContainer>

                            </Form>
                        )
                    }
                </div>
            </Panel>
        );
    }
};
